import {
  partnersCityPathSegment,
  partnersPathSegment,
} from '../../../../../sanity/schemas/utils/slugs/slugConstants';
import { toKebab } from '~/app/helpers/surpriseBagHelper';
import { urlToPathParts } from '~/app/helpers/sanity/urlToSlugParts';

export type BrandProfileRouteKind = 'page' | 'city' | 'other';

export interface ParsedBrandProfileRoute {
  kind: BrandProfileRouteKind;
  partnerSlug: string | null;
  citySlugLower: string | null;
}

function joinLocalizedPath(locale: string | undefined, segments: string[]): string {
  const tail = segments.join('/');
  return locale ? `/${locale}/${tail}` : `/${tail}`;
}

export function parseBrandProfileRoute(path: string): ParsedBrandProfileRoute {
  const parts = urlToPathParts(path);
  const [head, a, b] = parts;
  const len = parts.length;

  if (head === partnersCityPathSegment && len === 3) {
    return { kind: 'city', partnerSlug: b ?? null, citySlugLower: a ?? null };
  }
  if (head === partnersPathSegment && len === 2) {
    return { kind: 'page', partnerSlug: a ?? null, citySlugLower: null };
  }
  return { kind: 'other', partnerSlug: null, citySlugLower: null };
}

export function brandProfilePageUrl(locale: string | undefined, partnerSlug: string): string {
  return joinLocalizedPath(locale, [partnersPathSegment, partnerSlug]);
}

export function brandProfileCityUrl(
  locale: string | undefined,
  cityDisplayName: string,
  partnerSlug: string,
): string {
  const citySeg = toKebab(cityDisplayName, locale);
  return joinLocalizedPath(locale, [partnersCityPathSegment, citySeg, partnerSlug]);
}

export interface ResolvePartnerSlugParams {
  profileSlug?: string | null;
  path: string;
  brandNameFallback: string;
}

export function resolvePartnerSlugSegment(params: ResolvePartnerSlugParams): string {
  const fromSlug = params.profileSlug?.trim().toLowerCase();
  if (fromSlug) {
    return fromSlug;
  }
  return parseBrandProfileRoute(params.path).partnerSlug ??
    params.brandNameFallback.trim().toLowerCase();
}
